module.exports = __webpack_public_path__ + "img/boletim.bf18037b.jpg";